export const SET_LOADING_PERCENTAGE = 'SET_LOADING_PERCENTAGE';
